import React, { useEffect, useState } from 'react';
import { useFormContext } from "react-hook-form";
import useApiUrlTranslation from './useApiUrlTranslation';
import parse from 'html-react-parser';

const Programme = ({ programme }) => {

    const { register } = useFormContext();

    return <tr>
        <td><input type="checkbox"  {...register("programmeList")} value={programme.id_demande_referencement_programme_innovation} /></td>
        <td><img src={`http://www.mlg-consulting.com/manager_cc/docs/archives/${programme.logo}`} alt="" style={{ width: '30px' }} /></td>
        <td>{programme.programm_title}</td>
    </tr>
}

const RegistrationFormProgrammeInnovation = ({ cycleLang }) => {

    const { t, i18n, apiUrlTranslation } = useApiUrlTranslation();
    const [programmeList, setProgrammeList] = useState();

    const fetchProgrammes = async () => {

        await fetch(`${apiUrlTranslation}?action=getDemandesReferencement&id_cycle_lang=${cycleLang.id_cycle_lang}`)
            .then(res => res.json())
            .then(res => setProgrammeList(res))
    }

    useEffect(() => {
        fetchProgrammes();
    }, [cycleLang, i18n.resolvedLanguage]);

    return <div>
        <div className="modal fade" id="exampleModal" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-xl">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="exampleModalLabel"> {t('form.sections.programmes_innovation.section_title')}</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                        <div className="alert alert-info">{parse(t('form.sections.programmes_innovation.section_instructions'))}</div>
                        <table className="table table-sm ">
                            <tbody>
                                {programmeList && programmeList.map(item => <Programme key={item.id_demande_referencement_programme_innovation} programme={item} />)}
                            </tbody>
                        </table>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">{t('global.fermer')}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
}

export default RegistrationFormProgrammeInnovation;
